import { render, staticRenderFns } from "./extAttrItem.vue?vue&type=template&id=fca630ce&scoped=true&"
import script from "./extAttrItem.vue?vue&type=script&lang=js&"
export * from "./extAttrItem.vue?vue&type=script&lang=js&"
import style0 from "./extAttrItem.vue?vue&type=style&index=0&id=fca630ce&lang=scss&scoped=true&"
import style1 from "./extAttrItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca630ce",
  null
  
)

export default component.exports